import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface F2111 {
  f2111_01: string;   // 入庫單號 (FK)
  f2111_11: string;   // 品號
  f2111_13: number;   // 入庫數量
  f2111_14: number;   // 單價
}

export interface F2110 {
  f2110_01: string;         // 入庫單號
  f2110_07: string;         // 廠商代碼
  f2110_11: string | null;  // 入庫日期
  f2110_12: string;         // 庫位代碼
  f2110_13: string;         // 供應商代碼
  f2110_20: number;         // 總金額
  f2110_80: string;         // 核准狀態
  f2110_81: string;         // 核准人員
  f2110_82: string | null;  // 核准日期
  details?: F2111[];
}

export interface QueryRequest {
  dateFrom: string;
  dateTo: string;
  vendorFrom: string;
  vendorTo: string;
}

export interface QueryResponse {
  data: F2110[];
}

export interface ApproveRequest {
  receiptNos: string[];
  postToInventory: boolean;
  confirmed: boolean;
}

export interface ApproveResponse {
  approved: number;
  posted: number;
  message: string;
}

export interface UnapproveRequest {
  receiptNos: string[];
  confirmed: boolean;
}

export interface UnapproveResponse {
  unapproved: number;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pw2501Api = {
  // POST /api/pw2501/query
  async query(params: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw2501/query', params);
    return res.data;
  },

  // POST /api/pw2501/approve
  async approve(receiptNos: string[], postToInventory: boolean): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pw2501/approve', {
      receiptNos,
      postToInventory,
      confirmed: true,
    });
    return res.data;
  },

  // POST /api/pw2501/unapprove
  async unapprove(receiptNos: string[]): Promise<UnapproveResponse> {
    const res = await apiClient.post('/api/pw2501/unapprove', {
      receiptNos,
      confirmed: true,
    });
    return res.data;
  },

  // GET /api/pw2501/lookup/:type/:code
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw2501/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
